// extracted by mini-css-extract-plugin
export default {"banner":"StatisticsBanner_banner__i0FEu","statistics":"StatisticsBanner_statistics__s7-UP","stat":"StatisticsBanner_stat__jqOYh","statLabel":"StatisticsBanner_statLabel__u8iny"};